export function renderPartners(partners){
    let partnersHTML = '';

    for (let i = 0; i < partners.length; i++) {
        partnersHTML += ` <img class="ticket-system__choose-sector-partner-block" src="${partners[i]}" alt="">`
    }

    $('#ticket_system_choose_sector_partners').html(partnersHTML);
}